// extracted by mini-css-extract-plugin
module.exports = {"buy-button":"BuyButton_buy-button__23RUz"};